import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, User } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DashboardLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("dd_token", res.data.token);
      navigate("/dashboard");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B110E] flex items-center justify-center px-4" data-testid="dashboard-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-[#D95D39] rounded-sm flex items-center justify-center font-black text-white text-2xl mx-auto mb-4">DD</div>
          <h1 className="text-[#F8FAFC] font-black text-2xl tracking-tighter">Owner Dashboard</h1>
          <p className="text-[#64748B] text-sm mt-1">Double D Trapping LLC</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-5 border border-[#1F2937] rounded-sm p-6 bg-[#0F1A15]" data-testid="login-form">
          <div>
            <Label className="text-[#F8FAFC] text-sm font-semibold mb-2 block">Username</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
              <Input data-testid="login-username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" className="bg-[#0B110E] border-[#1F2937] text-[#F8FAFC] pl-10 h-11 rounded-sm focus-visible:ring-[#D95D39]" />
            </div>
          </div>
          <div>
            <Label className="text-[#F8FAFC] text-sm font-semibold mb-2 block">Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#64748B]" />
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="bg-[#0B110E] border-[#1F2937] text-[#F8FAFC] pl-10 h-11 rounded-sm focus-visible:ring-[#D95D39]" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full bg-[#D95D39] hover:bg-[#c04d2d] disabled:opacity-50 text-white font-bold uppercase tracking-widest text-sm py-3 rounded-sm transition-colors duration-150">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
